import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from 'sleep-promise';
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter()

    const path = '/demonstratives/';
    const paths = {
        endpointSave: config.endpoints.backend + 'demonstratives/save',
        endpointGetById: config.endpoints.backend + 'demonstratives/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllDemonstrativeTypes: config.endpoints.backend + 'demonstrativetypes/getall',
        endpointGetAllDemonstrativePeriods: config.endpoints.backend + 'demonstrativeperiods/getall',
        endpointGetAllOptionsByPeriodId: config.endpoints.backend + 'demonstrativeperiods/getOptionsById',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Demonstrativo",
        labelTitleEdit: "Editar Demonstrativo",
        labelTitleView: 'Visualizar Demonstrativo'
    }


    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_demonstrative_type_id',
                    type: 'select',
                    label: 'Tipo de Demonstrativo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDemonstrativeTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_demonstrative_period_id',
                    type: 'select',
                    label: 'Período de Demonstrativo',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllDemonstrativePeriods,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    }
                },
                values.pdc_demonstrative_period_id != keys?.default_foreign_key?.pdc_demonstrative_periods.yearly && values.pdc_demonstrative_period_id ? {
                    name: 'period',
                    type: 'select',
                    label: 'Referência',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllOptionsByPeriodId,
                        label: 'label',
                        value: 'value',
                        params: {
                            id: values.pdc_demonstrative_period_id
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    sort: false
                } : {},
                {
                    name: 'year',
                    type: 'year',
                    label: 'Ano',
                    selectable: true,
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'obs',
                    type: 'text',
                    label: 'Descrição',
                    validations: {
                        required: false
                    },
                    maxLength: 100
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: 10000,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
